import HttpRequest from '../http_request'

class WebHookApi extends HttpRequest {
  apiGetgenerateToken () {
    return this.fetch('/client/v1/webhook-markup/generate/token')
  }  
  apiGetListWebHook(data){
    return this.fetch(`/client/v1/webhook-markup`,data)
  }
  apiGetListWebHookById(id){
    return this.fetch(`/client/v1/webhook-markup/${id}`)
  }
  apiCreateWebHook(data){
    return  this.create(`/client/v1/webhook-markup`,data)
  }
  apiEditupdateWebHook(data){
    return this.edit(`/client/v1/webhook-markup/${data.id}`,data.formData)
  }
  apiDeleteWebHook(id){
    return this.delete(`/client/v1/webhook-markup/${id}`)
  }
}

export default WebHookApi
